import { jsx } from 'panel';
import { LineChartEl } from 'common/charts/visualization/line-chart';
import { DisplayAnalysisType } from 'common/charts/visualization/line-chart/enums';
import { SegmentLegendHeaderEl } from 'common/charts/misc/segment-legend-header';
import { NoDataHero } from 'common/widgets/warning-hero/presets';
import { WarningHeroReportName } from 'common/widgets/warning-hero/constants';
export function template() {
  if (!this.helpers.hasResults()) {
    return jsx("div", {
      sel: '.retention-line-chart'
    }, jsx(NoDataHero, {
      reportName: WarningHeroReportName.Retention
    }));
  }

  return jsx("div", {
    sel: '.root'
  }, jsx(SegmentLegendHeaderEl, {
    sel: '.segment-header'
  }), jsx(LineChartEl, {
    sel: '.line-chart',
    attrs: {
      'chart-width': null,
      'display-analysis-type': DisplayAnalysisType.Linear,
      'incomplete-to-date': this.helpers.isEndDateIncomplete(),
      timezone: this.helpers.getProjectTimezone(),
      'utc-offset': this.helpers.getUtcOffset(),
      'time-unit': this.helpers.getTimeUnit(),
      'zoom-type': "x",
      'show-annotations': this.attr("show-annotations")
    },
    props: this.helpers.getLineChartProps()
  }));
}